export const retouchingFaqs = [
  {
    question: "What is photo retouching?",
    answer:
      "Photo retouching involves fine-tuning and enhancing images by removing blemishes, smoothing skin, whitening teeth, reducing wrinkles, fixing flyaway hair, and refining other details while keeping the image natural.",
  },
  {
    question: "How is retouching different from basic editing?",
    answer:
      "Basic editing includes color correction, cropping, and exposure adjustments. Retouching goes deeper into enhancing facial features, backgrounds, textures, and removing distractions or imperfections for a flawless result.",
  },
  {
    question: "What types of retouching services do you offer?",
    answer:
      "We specialize in: Skin smoothing & tone correction, Blemish and acne removal, Teeth whitening & eye brightening, Flyaway hair removal, Body reshaping (if requested), Background cleanup & object removal, Fashion and beauty retouching, High-end frequency separation & dodge & burn.",
  },
  {
    question: "What’s the turnaround time for retouching?",
    answer:
      "It depends on the volume and complexity: Standard portraits: 24–36 hours. High-end/fashion sets: 3–5 business days. Rush options are available.",
  },
  {
    question: "Can I request revisions?",
    answer:
      "Yes, we offer free minor revisions to ensure you're fully satisfied with the result.",
  },
  {
    question: "Do you work with RAW files or JPEGs?",
    answer:
      "We prefer RAW or TIFF files for maximum editing flexibility, but high-res JPEGs are also acceptable.",
  },
  {
    question: "How do I send my photos and get started?",
    answer:
      "Just send us your files via our Uploader & cloud link (WeTransfer, Google Drive, Dropbox), tell us your requirements, and we’ll take care of the rest.",
  },
];
